import { render, staticRenderFns } from "./achievement.vue?vue&type=template&id=2e87b679&scoped=true&"
import script from "./achievement.vue?vue&type=script&lang=js&"
export * from "./achievement.vue?vue&type=script&lang=js&"
import style0 from "./achievement.vue?vue&type=style&index=0&id=2e87b679&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e87b679",
  null
  
)

export default component.exports